<template>
  <div>
    <form id="booking-form">
      <div class="form-group">
        <label for="nom">Nom<strong style="color: red">*</strong></label>
        <input type="text" class="form-control" id="nom" :disabled="isDisabled()"
               placeholder="Dupont" required>
      </div>
      <div class="form-group">
        <label for="prenom">Prénom<strong style="color: red">*</strong></label>
        <input type="text" class="form-control" id="prenom" :disabled="isDisabled()"
               placeholder="Jean" required>
      </div>
      <div class="form-group">
        <label for="email">Adresse email<strong style="color: red">*</strong></label>
        <input type="email" class="form-control" id="email" :disabled="isDisabled()"
               placeholder="jean.dupont@gmail.com" required>
      </div>
      <div class="form-group">
        <label for="telephone">Téléphone<strong style="color: red">*</strong></label>
        <input type="text" class="form-control" id="telephone" :disabled="isDisabled()"
               placeholder="06XXXXXXXX">
      </div>
      <div class="form-group"
           v-if="isBooking">
        <label for="birth_date">Date de naissance<strong style="color: red">*</strong></label>
        <input type="date" id="birth_date" name="date" :disabled="isDisabled()"
               placeholder="jj/mm/AAAA" class="form-control"
               min="1900-01-01" max="2100-12-31" required>
      </div>
    </form>
    <button type="button" class="btn btn-primary btn-lg mb-2" v-on:click="sendAppointmentRequest()"
            :disabled="isDisabled()">
      <i class="fa fa-check" v-show="!bookingLoading"></i>
      Réserver
      <i v-show="bookingLoading" class="fas fa-spin fa-spinner"></i>
    </button>
    <button type="button"
            v-if="isBooking"
            class="btn btn-secondary btn-lg mb-2" v-on:click="onCancelClicked()"
            :disabled="isDisabled()">
      Annuler
    </button>
    <div v-if="bookingSuccess" class="alert alert-success mt-2" role="alert">
      <i class="fa fa-check fas"></i>
      {{ isBooking ?
      'Votre rendez-vous à bien été pris en compte. Vous devez le confirmer sous 2 heures en cliquant sur le lien que vous venez de recevoir par e-mail.' :
      'Votre demande a bien été envoyée !'
      }}
    </div>
    <div v-if="bookingError" class="alert alert-danger" role="alert">
      <i class="fa fa-times fas"></i>
      Une erreur est survenue. <br/>
      Merci de réessayer plus tard.
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import fr from 'dayjs/locale/fr';

const LOCALE = 'fr';
const TIMEZONE = 'Europe/Paris';
const TIMEOUT = 30 * 1000;

export default {
  name: "ContactForm",
  props: ['isBooking', 'selectedEvent', 'osteoId'],
  data() {
    return {
      bookingSuccess: false,
      bookingLoading: false,
      bookingError: false
    };
  },
  mounted() {
    dayjs.locale(LOCALE);
    dayjs.extend(utc);
    dayjs.extend(timezone);
  },
  methods: {
    isDisabled() {
      return this.isBooking && !this.selectedEvent;
    },
    onCancelClicked() {
      this.$emit('bookingCancel');
    },
    setBookingLoading(value) {
      if (value) {
        this.bookingLoading = true;
        this.$emit('bookingLoadingStart');
      } else {
        this.bookingLoading = false;
        this.$emit('bookingLoadingEnd');
      }
    },
    sendAppointmentRequest() {
      let error = false;
      const formFields = ['#nom', '#prenom', '#email', '#telephone', '#birth_date'];
      const invalidClass = 'is-invalid';

      formFields.forEach(
        label => {
          console.log(label);
          const jQueryElement = $(label);
          if (!jQueryElement.val()) {
            jQueryElement.addClass(invalidClass);
            error = true;
          } else {
            jQueryElement.removeClass(invalidClass);
          }
        }
      );

      if (!error) {
        this.setBookingLoading(true);
        const prenomInput = $('#prenom').val();
        const birthDate = $('#birth_date').val();

        const appointment = {
          start: dayjs(this.selectedEvent.start).tz(TIMEZONE).toISOString(),
          end: dayjs(this.selectedEvent.end).tz(TIMEZONE).toISOString(),
          prenom: prenomInput.charAt(0).toUpperCase() + prenomInput.slice(1).toLowerCase(),
          nom: $('#nom').val().toUpperCase(),
          telephone: $('#telephone').val(),
          email: $('#email').val(),
        };

        if (birthDate) {
          appointment.birthDate = dayjs(birthDate).toISOString();
        }

        if (this.isBooking) {
          $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            data: {
              action: 'osteo_single',
              isBooking: true,
              id: this.osteoId,
              appointment
            },
            success: result => {
              console.log(result);
              if (result.code === 200) {
                formFields.forEach(
                  label => {
                    const jQueryElement = $(label);
                    jQueryElement.val("");
                  }
                );
                this.bookingSuccess = true;
                setTimeout(() => this.bookingSuccess = false, TIMEOUT);
                this.$emit('bookingSuccess');
              } else {
                this.bookingError = true;
                setTimeout(() => this.bookingError = false, TIMEOUT);
              }

            },
            error: errorApi => {
              console.error(errorApi);
              this.bookingError = true;
              setTimeout(() => this.bookingError = false, TIMEOUT);
            },
            complete: () => this.setBookingLoading(false)
          });
        } else {
          $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            data: {
              action: 'osteo_single',
              isBooking: false,
              nom,
              prenom,
              telephone: $('#telephone').val(),
              email_patient: $('#email').val(),
              email_praticien: $('#osteo-email').val(),
            },
            success: result => {
              console.log(result);
              formFields.forEach(
                label => {
                  const jQueryElement = $(label);
                  jQueryElement.val("");
                }
              );
              this.bookingSuccess = true;
              setTimeout(() => this.bookingSuccess = false, 10000);
            },
            error: errorApi => {
              console.error(errorApi);
              this.bookingError = true;
              setTimeout(() => this.bookingError = false, 10000);
            },
            complete: () => this.setBookingLoading(false)
          });
        }
      } else {
        console.log('form is not valid');
      }

    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/ContactForm.vue